import { Group } from '@mantine/core'
import React, { useMemo } from 'react'

import {
  FilterDefinitionWithoutComponent,
  FullTextFilterDefinition,
} from '../hooks/useDebouncedFilterValue/use-debounced-filter-value'
import { FilterChipsProps } from './filter-chips'
import FilterChip from './FilterChip'

const FilterChips = ({
  sortFilter,
  filterDefinitions,
}: FilterChipsProps): React.ReactElement => {
  const relevantFilters: Exclude<
    FilterDefinitionWithoutComponent,
    FullTextFilterDefinition
  >[] = useMemo(() => {
    return filterDefinitions.filter(
      (f) => 'type' in f && f.type !== 'fulltext',
    ) as Exclude<FilterDefinitionWithoutComponent, FullTextFilterDefinition>[]
  }, [sortFilter.activeFilters, filterDefinitions])

  if (relevantFilters.length === 0) {
    return <></>
  }

  return (
    <Group>
      {relevantFilters.map((rf) => (
        <FilterChip
          key={`${rf.name}-chip-key`}
          filterDefinition={rf}
          activeFilters={sortFilter.activeFilters}
          setFilterValue={sortFilter.setActiveFilterValue}
        />
      ))}
    </Group>
  )
}

export default FilterChips
